<template>
<div v-if="icons" class="SocialMediaIcons" v-bind:class="{ white: white }">
    <ul>
        <ol v-if="icons.Instagram" class="Instagram">
            <a :href="icons.Instagram.link" target="blank">
                <svg xmlns="http://www.w3.org/2000/svg" :width=iconsWidth :height=iconsWidth viewBox="0 0 24 24">
                    <path d="M11.984 16.815c2.596 0 4.706-2.111 4.706-4.707 0-1.409-.623-2.674-1.606-3.538-.346-.303-.735-.556-1.158-.748-.593-.27-1.249-.421-1.941-.421s-1.349.151-1.941.421c-.424.194-.814.447-1.158.749-.985.864-1.608 2.129-1.608 3.538 0 2.595 2.112 4.706 4.706 4.706zm.016-8.184c1.921 0 3.479 1.557 3.479 3.478 0 1.921-1.558 3.479-3.479 3.479s-3.479-1.557-3.479-3.479c0-1.921 1.558-3.478 3.479-3.478zm5.223.369h6.777v10.278c0 2.608-2.114 4.722-4.722 4.722h-14.493c-2.608 0-4.785-2.114-4.785-4.722v-10.278h6.747c-.544.913-.872 1.969-.872 3.109 0 3.374 2.735 6.109 6.109 6.109s6.109-2.735 6.109-6.109c.001-1.14-.327-2.196-.87-3.109zm2.055-9h-12.278v5h-1v-5h-1v5h-1v-4.923c-.346.057-.682.143-1 .27v4.653h-1v-4.102c-1.202.857-2 2.246-2 3.824v3.278h7.473c1.167-1.282 2.798-2 4.511-2 1.722 0 3.351.725 4.511 2h7.505v-3.278c0-2.608-2.114-4.722-4.722-4.722zm2.722 5.265c0 .406-.333.735-.745.735h-2.511c-.411 0-.744-.329-.744-.735v-2.53c0-.406.333-.735.744-.735h2.511c.412 0 .745.329.745.735v2.53z" /></svg>
            </a>
        </ol>
        <ol v-if="icons.Facebook" class="Facebook">
            <a :href="icons.Facebook.link" target="blank">
                <svg xmlns="http://www.w3.org/2000/svg" :width=iconsWidth :height=iconsWidth viewBox="0 0 24 24">
                    <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z" /></svg>
            </a>
        </ol>
        <ol v-if="icons.Twitter" class="Twitter">
            <a :href="icons.Twitter.link" target="blank">
                <svg xmlns="http://www.w3.org/2000/svg" :width=iconsWidth :height=iconsWidth viewBox="0 0 24 24">
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" /></svg>
            </a>
        </ol>
        <ol v-if="icons.Linkedin" class="Linkedin">
            <a :href="icons.Linkedin.link" target="blank">
                <svg xmlns="http://www.w3.org/2000/svg" :width=iconsWidth :height=iconsWidth viewBox="0 0 24 24">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" /></svg>
            </a>
        </ol>
    </ul>
</div>
</template>

<script>
export default {
    name: "SocialMediaIcons",
    props: {
        icons: Object,
        white: Boolean,
        iconsWidth: String
    }
};
</script>

<style lang="scss" scoped>
@import "../scss/colors";

ul {
    display: flex;

    ol {
        margin-left: 5px;
        margin-right: 5px;
    }

    svg {
        transition: transform .3s;
        backface-visibility: hidden;
        -webkit-font-smoothing: subpixel-antialiased;
        will-change: transform;
        transform: scale(1) perspective(1px) translateZ(0);

        path {
            fill: $blue;
        }

        &:hover {
            transform: scale(1.1) perspective(1px) translateZ(0);
        }
    }
}

.white {
    path {
        fill: white;
    }
}

.isBlue {
    path {
        fill: $blue;
    }
}
</style>
